export default function SuitableCompanies() {
  const industries = [
    { icon: 'ri-building-2-line', name: 'B2B' },
    { icon: 'ri-ship-line', name: 'Логистика' },
    { icon: 'ri-code-box-line', name: 'IT' },
    { icon: 'ri-hammer-line', name: 'Производство' },
    { icon: 'ri-truck-line', name: 'Дистрибуция' },
    { icon: 'ri-home-gear-line', name: 'Строительство' },
    { icon: 'ri-bank-line', name: 'Финансы' },
    { icon: 'ri-service-line', name: 'Услуги' },
    { icon: 'ri-building-4-line', name: 'Недвижимость' },
    { icon: 'ri-restaurant-line', name: 'HoReCa' },
    { icon: 'ri-shopping-bag-3-line', name: 'Оптовые продажи' },
    { icon: 'ri-global-line', name: 'Экспорт' },
  ];

  return (
    <section id="industries" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Для каких компаний подходит обучение
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа адаптируется под любую отрасль и модель продаж. Главное — наличие потребности в привлечении новых клиентов через телефонные переговоры.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 max-w-5xl mx-auto">
          {industries.map((ind, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 text-center hover:bg-teal-50 transition-colors duration-300 border border-gray-100 hover:border-teal-200">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mx-auto mb-3">
                <i className={`${ind.icon} text-xl text-white`}></i>
              </div>
              <span className="text-sm font-semibold text-gray-900">{ind.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}